import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const stripetransactions = createAsyncThunk('appStripe/stripetransactions', async (Vehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetStripeTransactions', Vehicle, { mode: 'cors' })

  return response
})
export const getStripeEventsList = createAsyncThunk('appStripe/getStripeEventsList', async (Vehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetStripeTransactionsEventLog', Vehicle, { mode: 'cors' })

  return response
})
export const getLivestatus = createAsyncThunk('appStripe/getLivestatus', async (Vehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetStripeLiveStatus', Vehicle, { mode: 'cors' })

  return response
})

export const appStripeSlice = createSlice({
  name: 'appStripe',
  initialState: {
    data: []
   
  },
  reducers: {}
//   extraReducers: builder => {
//     builder

    
//   }
})

export default appStripeSlice.reducer
